import { FormApiInterface } from 'react-uforms';

import { CustomFlowId, Question } from '@ch/common/types/data';
import { getAgeGroup } from './age-unit';
import { DropdownData } from '../types';

interface SpecificFlowsProps {
  changedField: string;
  api: FormApiInterface;
  dropdownData: DropdownData;
  userQuestions: Question[];
}

const patientAgeFlow = (props: SpecificFlowsProps) => {
  const { api, dropdownData, userQuestions } = props;

  const unit = api.getValue(CustomFlowId.AGE_UNIT);
  const age = api.getValue(CustomFlowId.PATIENT_AGE);

  if (unit) {
    const ageUnitQuestion = userQuestions.find(({ identifier }) => identifier === CustomFlowId.AGE_UNIT);
    const ageGroupQuestion = userQuestions.find(({ identifier }) => identifier === CustomFlowId.AGE_GROUP);

    const e2bAgeUnit = dropdownData[ageUnitQuestion.file]?.rawOptions.find(({ value }) => value === unit)?.e2b_code;
    if (e2bAgeUnit) {
      const { value: ageValue, e2b: ageE2b } = getAgeGroup(+age, e2bAgeUnit.toString());

      const ageLocalizedValue = dropdownData[ageGroupQuestion.file]?.rawOptions.find(({ e2b_code: e2b }) =>
        [ageE2b, ageValue].includes(e2b.toString()),
      )?.value;
      api.setValue(CustomFlowId.AGE_GROUP, ageLocalizedValue);
    }
  }
};

export const adaptSpecificFlows = (props: SpecificFlowsProps) => {
  const { changedField, api } = props;
  if (
    (changedField === CustomFlowId.AGE_UNIT || changedField === CustomFlowId.PATIENT_AGE) &&
    api.getValue(CustomFlowId.AGE_UNIT)
  ) {
    patientAgeFlow(props);
  }
};
